import { useTranslation } from 'react-i18next';

import useLessonStatusMessage from 'core/hooks/useLessonStatusMessage';

export type SignUpStatusProps = {
  isLoading: boolean;
};

type UseSignUpStatus = { message: string };

/** Solo se anuncia la carga: los errores salen en su campo o en un aviso, que ya se anuncian solos. */
function useSignUpStatus({ isLoading }: SignUpStatusProps): UseSignUpStatus {
  const { t } = useTranslation();

  const message = useLessonStatusMessage({
    isLoading,
    messages: { loading: t('alt:Loading') },
    result: 'content',
  });

  return { message };
}

export default useSignUpStatus;
